export { }
import { parse } from 'date-fns';
declare global {
    interface String {
        Mask(type: 'phone' | 'email'): string;
        mobileRaw(): string;
        mobileFormat(): string;
        toDate(dateFormat?: string): Date;
        isNullOrEmpty(): boolean;
    }
}

String.prototype.Mask = function (type: 'phone' | 'email'): string {
    if (this) {
        if (type == "phone" && this.length > 4) {
            return `(***)***-${this.substring((this.length - 4), (this.length))}`
        } else {
            return `*****${this.substring(5, (this.length))}`
        }
    }
    return this as string;
}

String.prototype.mobileRaw = function (): string {
    if (this) {
        return this.replaceAll('-', '').replaceAll('(', '').replaceAll(')', '')
    }
    return this as string;
}

String.prototype.mobileFormat = function (): string {
    const phoneNumber = this.replace(/\D/g, '');
    if (phoneNumber.length !== 10) {
        return this.toString();
    }
    return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`;
}

String.prototype.toDate = function (dateFormat?: string): Date {
    if (this) {
        if (!dateFormat) dateFormat = "MM/dd/yyyy h:m:s aa";
        return parse(this.toString(), dateFormat, new Date());
    }
    return null;
}

String.prototype.isNullOrEmpty = function (): boolean {
    return this === null || this === undefined || this.trim().length === 0;
};

declare global {
    interface Number {
        ceil(num: number, decimals?: number): number;
    }
}

Number.prototype.ceil = function (num: number, decimals: number = 2): number {
    const factor = 10 ** decimals;
    return Math.ceil(num * factor) / factor;
}